<template>
  <fragment>
    <tr
      v-for="(docInfo, fIndex) in docs"
      :key="docInfo.FILE_INFO.ID ? docInfo.FILE_INFO.ID : fIndex"
    >
      <td>
        <span v-if="fIndex === 0">{{ index }}.{{ docIndex + 1 }}</span>
      </td>
      <td class="nl tab-wid-25">
        <VDropdown
          v-if="docInfo.HELP_REPORT_TYPE"
          tag="span"
          trigger="click"
          placement="bottom"
          popperClass="custom-popper"
          :distance="25"
        >
          <a class="icon-help-blue" style="">
          </a>
          <template #popper>
            <div class="custom-popper-content" v-html="docInfo.HELP_REPORT_TYPE" />
          </template>
        </VDropdown>
        <VDropdown
          v-else-if="docInfo.HELP"
          tag="span"
          trigger="click"
          placement="bottom"
          popperClass="custom-popper"
          :distance="25"
        >
          <a class="icon-help-blue" style="">
          </a>
          <template #popper>
            <div class="custom-popper-content" v-html="docInfo.HELP" />
          </template>
        </VDropdown>
      </td>
      <td class="nl tab-wid-25">
<!--        <VDropdown
          v-if="docInfo.IS_NEED_APPROVAL_FRP"
          tag="span"
          trigger="click"
          placement="bottom"
          popperClass="custom-popper"
          :distance="25"
        >
          <a class="icon-help-blue">
            &nbsp;
          </a>
&lt;!&ndash;          <template #popper>
            <div class="custom-popper-content">
              Документ требует согласования со стороны ФРП
            </div>
          </template>&ndash;&gt;
        </VDropdown>-->
      </td>
      <td class="nl tab-wid-25">
        <a
          v-if="docInfo.SHABLON_REPORT_TYPE_LINK"
          class="icon-shablon-blue"
          :href="docInfo.SHABLON_REPORT_TYPE_LINK"
          target="_blank"
          style="display: inline-block;position: initial; width: 40px; margin-top: 16px;"
        ></a>
        <a
          v-else-if="docInfo.SHABLON_LINK"
          class="icon-shablon-blue"
          :href="docInfo.SHABLON_LINK"
          target="_blank"
          style="display: inline-block;position: initial; width: 40px; margin-top: 16px;"
        ></a>
        <a
          v-else-if="docInfo.SHABLON"
          class="icon-shablon-blue"
          :href="docInfo.SHABLON"
          target="_blank"
          style="display: inline-block;position: initial; width: 40px; margin-top: 16px;"
        >
        </a>
      </td>
      <!-- Ссылка Наименование документа -->
      <td>
        <a
          style="display: inline-block"
          v-if="docInfo.FILE_INFO && docInfo.FILE_INFO.FILE_OTH"
          @click="showDocHistory(docInfo.FILE_INFO.ID)"
          v-html="docInfo.NAME_NEW_TYPE ? docInfo.NAME_NEW_TYPE : docInfo.NAME"
        >
        </a>
        <div style="display: inline-block" v-else>
          <span
            v-html="
              docInfo.NAME_NEW_TYPE ? docInfo.NAME_NEW_TYPE : docInfo.NAME
            "
          ></span>
        </div>

        <div v-if="docInfo.FILE_INFO && docInfo.FILE_INFO.TRANSH_IS_lINK == 1">
          <a
            class="btn btn-primary tab-but-doc"
            style="margin-top: 10px; "
            :href="docInfo.FILE_INFO.TRANSH_URL"
            target="_blank"
            v-html="docInfo.FILE_INFO.TRANSH_LINK_NAME"
          >
          </a>
        </div>

        <i
          @click="
            showEditTableDialog(
              docInfo.FILE_INFO.ID,
              docInfo.NAME_NEW_TYPE ? docInfo.NAME_NEW_TYPE : docInfo.NAME
            )
          "
          v-if="
            (docInfo.FILE_INFO &&
              docInfo.FILE_INFO.UF_IS_REQ_DOC &&
              isManagerRequest(
                docInfo
              )) /*||
              (docInfo.FILE_INFO &&
                docInfo.FILE_INFO.UF_IS_ADD_DOC &&
                docInfo.IS_LOAD_FILE_USER === 1 &&
                (currentUser.ACTIVE_ROLE_CODE === 'lizing' ||
                  currentUser.ACTIVE_ROLE_CODE === 'users'))*/ ||
              (docInfo.IS_MULTY === 1 &&
                docInfo.IS_REQUEST_DOC === 0 &&
                docInfo.IS_REQUEST_USER_DOC_ADD === 1 &&
                docInfo.IS_LOAD_FILE_USER === 1 &&
                (currentUser.ACTIVE_ROLE_CODE === 'admin' ||
                  currentUser.ACTIVE_ROLE_CODE === 'OMP_staff'))
          "
          class="i-edit"
        ></i>

        <template
          v-if="
            docInfo.IS_ECP_REQ === 1 &&
              docInfo.FILE_INFO &&
              docInfo.FILE_INFO.ID > 0 &&
              docInfo.FILE_INFO.UF_FILE_SIGN_AUTHOR != null &&
              docInfo.FILE_INFO.UF_FILE_SIGN_AUTHOR != ''
          "
        >
          <div class="esd-data">
            <i
              class="esd-data-link"
              style="margin-top: 10px;"
              @click="getECPInfo(docInfo.FILE_INFO.ID)"
            >
              <img src="/images/i-eds.png" />
              {{ docInfo.FILE_INFO.UF_FILE_SIGN_AUTHOR }}
            </i>

            <div
              class="esd-data__info"
              v-show="resultECPFile[docInfo.FILE_INFO.ID]"
              style="right:0;"
            >
              <div
                class="esd-close"
                @click="closeECPFile(docInfo.FILE_INFO.ID)"
              >
                <i class="esd_exit"></i>
              </div>
              <div v-if="resultECPFile[docInfo.FILE_INFO.ID]">
                <p class="text-center">
                  Подлинник электронного документа, подписанного ЭЦП,
                  <br />хранится в информационной системе “Личный кабинет
                  заемщика” <br />Фонда развития промышленности
                </p>
                <h3 class="esd-title">Сведения о сертификате ЭП</h3>
                <div class="container-fluid">
                  <div class="row">
                    <div class="col-xs-4 col-md-4 stl-col-pb-8">
                      Сертификат:
                    </div>
                    <div class="col-xs-8 col-md-8 stl-col-pb-8 esd_wsn esd_wsn">
                      {{ result.SERTIFICATE_NUMBER }}
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-xs-4 col-md-4 stl-col-pb-8">Кем выдан:</div>
                    <div class="col-xs-8 col-md-8 stl-col-pb-8 esd_wsn">
                      {{ result.ISSUER }}
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-xs-4 col-md-4 stl-col-pb-8">
                      Организация:
                    </div>
                    <div class="col-xs-8 col-md-8 stl-col-pb-8 esd_wsn">
                      {{ result.COMPANY }}
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-xs-4 col-md-4 stl-col-pb-8">
                      Кому выдан:
                    </div>
                    <div class="col-xs-8 col-md-8 stl-col-pb-8 esd_wsn">
                      {{ result.OWNER_FIO }}
                    </div>
                  </div>
                  <div class="row" v-if="result.POSITION">
                    <div class="col-xs-4 col-md-4 stl-col-pb-8">
                      Должность:
                    </div>
                    <div class="col-xs-8 col-md-8 stl-col-pb-8 esd_wsn">
                      {{ result.POSITION }}
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-xs-4 col-md-4 stl-col-pb-8">
                      Действителен:
                    </div>
                    <div class="col-xs-8 col-md-8 stl-col-pb-8 esd_wsn">
                      {{ result.DATE_USE_SERTIFICATE }}
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-xs-4 col-md-4 stl-col-pb-8">
                      Название документа:
                    </div>
                    <div class="col-xs-8 col-md-8 stl-col-pb-8 esd_wsn">
                      {{ result.FILE_NAME }}
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-xs-4 col-md-4 stl-col-pb-8">
                      Дата загрузки:
                    </div>
                    <div class="col-xs-8 col-md-8 stl-col-pb-8 esd_wsn">
                      {{ docInfo.FILE_INFO.UF_FILE_DATE_LOAD }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
      </td>
      <!-- Вид документа -->
      <td>
        {{
          docInfo.VID_DOC_DZ_NAME
            ? docInfo.VID_DOC_DZ_NAME.join(" или ")
            : docInfo.TYPE_INFO.VID_DOC_DZ_NAME.join(" или ")
        }}
      </td>
      <UploadCellAddDZ
        :doc="doc"
        :docsType="docsType"
        :docs="docs"
        :project="project"
        :document-conf="documentConf"
      ></UploadCellAddDZ>
      <!-- Дата загрузки -->
      <td>
        {{
          docInfo.FILE_INFO && docInfo.FILE_INFO.UF_FILE_DATE_LOAD
            ? docInfo.FILE_INFO.UF_FILE_DATE_LOAD
            : ""
        }}
      </td>
      <td v-show="documentConf.IS_RFRP_PROGRAM">
        <template v-if="docInfo.FILE_INFO && docInfo.FILE_INFO.FILE">
          <div
            v-if="isSetAcceptManager(docInfo.GROUP_ACCEPT_RFRP_MANAGER_LIST)"
          >
            <select
              class="form-control"
              v-model="docInfo.FILE_INFO.UF_IS_AKCEPT_RFRP"
              @change="
                setAkceptRFRPManagerDocumentDZ(
                  docInfo.FILE_INFO.ID,
                  docInfo.FILE_INFO.UF_IS_AKCEPT_RFRP
                )
              "
              :disabled="
                docInfo.FILE_INFO.UF_ELECTRON_VIEW_ID == 1 ? true : false
              "
            >
              <option :value="0"></option>
              <option :value="1">Акцептован</option>
              <option :value="2">Отклонен</option>
            </select>
          </div>
          <div v-else-if="docInfo.FILE_INFO.UF_AKCEPT_RFRP_TEXT">
            {{ docInfo.FILE_INFO.UF_AKCEPT_RFRP_TEXT }}
          </div>
        </template>
      </td>
      <!-- modal ECP -->
      <td v-show="documentConf.IS_RFRP_PROGRAM">
        <div
          class="esd-data"
          v-if="
              docInfo.FILE_INFO &&
              docInfo.FILE_INFO.UF_AKCEPT_RFRP_TEXT &&
              docInfo.FILE_INFO.UF_MANAGER_AKCEPT_RFRP &&
              docInfo.FILE_INFO.UF_AKCEPT_RFRP_ECP_IS_VIEW_WINDOW == 1 &&
              !isSetAcceptManager(docInfo.GROUP_ACCEPT_RFRP_MANAGER_LIST)
          "
        >
          <i
            class="esd-data esd_icon"
            @click="getECPUserInfo(docInfo.FILE_INFO.UF_MANAGER_AKCEPT_RFRP)"
            style="margin-right: 15px; width: 60px;"
          >
            ЭЦП
            <img src="/images/i-eds.png" />
          </i>
          <div
            class="esd-data__info"
            v-show="resultECP[docInfo.FILE_INFO.UF_MANAGER_AKCEPT_RFRP]"
          >
            <div
              class="esd-close"
              @click="closeECP(docInfo.FILE_INFO.UF_MANAGER_AKCEPT_RFRP)"
            >
              <i class="esd_exit"></i>
            </div>
            <div v-if="resultECP[docInfo.FILE_INFO.UF_MANAGER_AKCEPT_RFRP]">
              <p class="text-center">
                Документ акцептован сотрудником {{ result.manager_name }},
                который авторизовался в системе при помощи ЭЦП
              </p>
              <h3 class="esd-title">Сведения о сертификате ЭП</h3>
              <div class="container-fluid">
                <div class="row">
                  <div class="col-xs-4 col-md-4 stl-col-pb-8">Сертификат:</div>
                  <div class="col-xs-8 col-md-8 stl-col-pb-8 esd_wsn esd_wsn">
                    {{ result.ECP ? result.ECP.SERTIFICATE_NUMBER : "-" }}
                  </div>
                </div>
                <div class="row">
                  <div class="col-xs-4 col-md-4 stl-col-pb-8">Кем выдан:</div>
                  <div class="col-xs-8 col-md-8 stl-col-pb-8 esd_wsn">
                    {{ result.ECP ? result.ECP.ISSUER : "-" }}
                  </div>
                </div>
                <div class="row">
                  <div class="col-xs-4 col-md-4 stl-col-pb-8">Организация:</div>
                  <div class="col-xs-8 col-md-8 stl-col-pb-8 esd_wsn">
                    {{ result.ECP ? result.ECP.COMPANY : "-" }}
                  </div>
                </div>
                <div class="row">
                  <div class="col-xs-4 col-md-4 stl-col-pb-8">Кому выдан:</div>
                  <div class="col-xs-8 col-md-8 stl-col-pb-8 esd_wsn">
                    {{ result.ECP ? result.ECP.OWNER_FIO : "-" }}
                  </div>
                </div>
                <div class="row" v-if="result.ECP && result.ECP.POSITION">
                  <div class="col-xs-4 col-md-4 stl-col-pb-8">Должность:</div>
                  <div class="col-xs-8 col-md-8 stl-col-pb-8 esd_wsn">
                    {{ result.ECP.POSITION }}
                  </div>
                </div>
                <div class="row">
                  <div class="col-xs-4 col-md-4 stl-col-pb-8">
                    Действителен:
                  </div>
                  <div class="col-xs-8 col-md-8 stl-col-pb-8 esd_wsn">
                    {{ result.ECP ? result.ECP.DATE_USE_SERTIFICATE : "-" }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </td>
      <!-- modal ECP -->
      <!-- Электронный вид, варианты акцепта /directory/hl/dz_accept_electronic_view/  -->
      <td style="min-width: 140px;">
        <template v-if="docInfo.FILE_INFO">
          <div
            class="form-group"
            style="margin-bottom: 0"
            v-if="
              docInfo.IS_ACCEPT_ELECTRONIC_FILE_MANAGER &&
                isSetAcceptManager(docInfo.GROUP_ACCEPT_ELECTRONIC_MANAGER_LIST)
            "
          >
            <!-- <label>Департамент</label> -->
            <select
              class="form-control"
              v-model="docInfo.FILE_INFO.UF_ELECTRON_VIEW_ID"
              @change="
                setElectornViewManagerDocumentDZ(
                  docInfo.FILE_INFO.ID,
                  docInfo.FILE_INFO.UF_ELECTRON_VIEW_ID
                )
              "
            >
              <option :value="0"></option>
              <option
                v-for="item in directory.hl_dz_accept_electronic_view"
                :key="item.ID"
                :value="item.ID"
                v-show="
                  !!(
                    docInfo.FILE_INFO['FILE'] ||
                    (!docInfo.FILE_INFO['FILE'] && item.ID === 3)
                  )
                "
                >{{ item.UF_NAME }}
              </option>
            </select>
          </div>
          <template v-else>
            <VDropdown
              v-if="docInfo.FILE_INFO.UF_ELECTRON_VIEW_TEXT"
              tag="span"
              trigger="click"
              placement="bottom"
              popperClass="custom-popper"
              :distance="25"
              style="display: inline"
            >
              <a
                class="icon-help-blue2"
                style="margin-right:4px; position: relative; height: auto"
              >
              &nbsp;
              </a>
              <template #popper>
                <div class="custom-popper-content">
                  {{
                    docInfo.FILE_INFO.UF_AUTHOR_ELECTRON_VIEW_ID_NAME +
                      " " +
                      docInfo.FILE_INFO.UF_DATE_AKCEPT_ELECTRON_VIEW
                  }}
                </div>
              </template>
            </VDropdown>{{ docInfo.FILE_INFO.UF_ELECTRON_VIEW_TEXT }}
          </template>
        </template>
      </td>
      <td v-if="documentConf.isViewElectornAccept">
        {{
          docInfo.FILE_INFO.UF_IS_VIEW_ELECTRON_ACCEPT &&
          docInfo.FILE_INFO.UF_AUTHOR_ELECTRON_VIEW_NAME
            ? docInfo.FILE_INFO.UF_AUTHOR_ELECTRON_VIEW_NAME
            : ""
        }}
      </td>
      <td v-if="documentConf.isViewElectornAccept">
        {{
          docInfo.FILE_INFO.UF_IS_VIEW_ELECTRON_ACCEPT &&
          docInfo.FILE_INFO.UF_DATE_AKCEPT_ELECTRON_VIEW
            ? docInfo.FILE_INFO.UF_DATE_AKCEPT_ELECTRON_VIEW
            : ""
        }}
      </td>
      <!-- бумажный вид - /directory/hl/dz_accept_paper_view/ -->
      <td style="min-width: 170px;">
        <template v-if="docInfo.FILE_INFO">
          <div
            class="form-group"
            style="margin-bottom: 0"
            v-if="
              docInfo.IS_ACCEPT_PAPER_FILE_MANAGER &&
                isSetAcceptManager(docInfo.GROUP_ACCEPT_PAPER_MANAGER_LIST)
            "
          >
            <!-- <label>Департамент</label> -->
            <select
              class="form-control"
              v-model="docInfo.FILE_INFO.UF_PAPER_VIEW_ID"
              @change="
                setPaperViewManagerDocumentDZ(
                  docInfo.FILE_INFO.ID,
                  docInfo.FILE_INFO.UF_PAPER_VIEW_ID
                )
              "
            >
              <option
                v-for="item in directory.hl_dz_accept_paper_view"
                :key="item.ID"
                :value="item.ID"
                >{{ item.UF_NAME }}
              </option>
            </select>
          </div>
          <template v-else>
            <template v-if="docInfo.FILE_INFO.UF_PAPER_VIEW_TEXT">
              <template v-if="docInfo.FILE_INFO.UF_AUTHOR_PAPER_VIEW_ID_NAME">
              <VDropdown
                tag="span"
                trigger="click"
                placement="bottom"
                popperClass="custom-popper"
                :distance="25"
                style="display: inline"
              >
                <a
                  class="icon-help-blue2"
                  style="margin-right:4px; position: relative; height: auto"
                >
                &nbsp;
                </a>
                <template #popper>
                  <div class="custom-popper-content">
                    {{
                      docInfo.FILE_INFO.UF_AUTHOR_PAPER_VIEW_ID_NAME +
                        " " +
                        docInfo.FILE_INFO.UF_DATE_AKCEPT_PAPER_VIEW
                    }}
                  </div>
                </template>
              </VDropdown>
                {{ docInfo.FILE_INFO.UF_PAPER_VIEW_TEXT }}
              </template>
              <span v-else>
                {{ docInfo.FILE_INFO.UF_PAPER_VIEW_TEXT }}
              </span>
            </template>
          </template>
        </template>
      </td>
      <td v-if="docInfo.FILE_INFO.UF_COMMENT_MANAGER" style="max-width: 250px;">
        {{ docInfo.FILE_INFO.UF_COMMENT_MANAGER }}
      </td>
      <td v-else></td>
      <td style="min-width: 30px;">
        <i
          class="i-edit centerIcon"
          v-if="
            docInfo.IS_MANAGER_SET_COMMENT === 1 &&
              isSetAcceptManager(docInfo.GROUP_COMMENT_MANAGER_LIST)
          "
          @click="showComment(docInfo.FILE_INFO, false)"
        ></i>
      </td>

      <td
        v-if="docInfo.FILE_INFO.UF_COMMENT_MANAGER_RFRP"
        style="max-width: 250px;"
      >
        {{ docInfo.FILE_INFO.UF_COMMENT_MANAGER_RFRP }}
      </td>
      <td v-else></td>
      <td style="min-width: 30px;" v-show="documentConf.IS_RFRP_PROGRAM">
        <i
          class="i-edit centerIcon"
          v-if="
            docInfo.IS_MANAGER_SET_RFRP_COMMENT === 1 &&
              isSetAcceptManager(docInfo.GROUP_COMMENT_MANAGER_RFRP_LIST)
          "
          @click="showComment(docInfo.FILE_INFO, true)"
        ></i>
      </td>

      <td v-if="docInfo.FILE_INFO">
        <i
          v-if="
            (docInfo.FILE_INFO &&
              docInfo.FILE_INFO.UF_IS_REQ_DOC &&
              isManagerRequest(docInfo)) ||
              (docInfo.FILE_INFO &&
                docInfo.FILE_INFO.UF_IS_ADD_DOC &&
                docInfo.IS_LOAD_FILE_USER === 1 &&
                isInRequestManagerList(docInfo)) ||
              (docInfo.IS_MULTY === 1 &&
                docInfo.IS_REQUEST_DOC === 0 &&
                docInfo.IS_REQUEST_USER_DOC_ADD === 1 &&
                docInfo.IS_LOAD_FILE_USER === 1 &&
                (currentUser.ACTIVE_ROLE_CODE === 'admin' ||
                  currentUser.ACTIVE_ROLE_CODE === 'OMP_staff'))
          "
          @click="deleteDocument(docInfo.FILE_INFO.ID)"
          class="i-delete centerIcon"
          style="margin: 0 10px;"
        ></i>
      </td>
      <td v-else></td>
      <td v-show="false">
        <span
          class="request-create"
          v-if="
            currentUser.TYPE_USER === 'manager' &&
              docInfo.FILE_INFO &&
              docInfo.FILE_INFO.FILE &&
              docInfo.FILE_INFO.TYPE_INFO_CODE !=
                'otchet_bank_garantiya_10_06' &&
              docInfo.FILE_INFO.TYPE_INFO_CODE !=
                'otchet_bank_garantiya_rfrp_10_06'
          "
          @click="showWindowCreateRequest(docInfo)"
        ></span>
      </td>
    </tr>
    <tr
      v-show="
        doc.TYPE_INFO.IS_REQUEST_DOC === 1 &&
          doc.IS_REQUEST_USER_DOC_ADD === 0 &&
          isSetAcceptManager(doc.GROUP_REQUEST_MANAGER_LIST) &&
          doc.IS_FILE_MANAGER_REQUEST
      "
    >
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td style="vertical-align: top;">
        <div v-if="showAddDocForm">
          <h4 class="h4form">Введите наименование документа:</h4>
          <input
            type="text"
            class="i-main-style tab-wid-550"
            v-model="reqDoc.UF_NAME"
          />
          <br /><br />
          <button
            type="button"
            class="btn btn-info"
            style="margin-right: 20px;"
            @click="addFile(doc.TYPE_ID)"
          >
            Запросить документ
          </button>

          <button
            type="button"
            class="btn btn-close_"
            @click="showAddDocForm = false"
          >
            Отмена
          </button>
        </div>
        <b v-else>
          <a @click="showAddDocForm = true" class="add-t-r"></a> Запросить
          документ
        </b>
      </td>
      <td style="vertical-align: top;">
        <div v-if="showAddDocForm">
          <h4 class="h4form">Вид документа:</h4>
          <ul class="ul-list-form">
            <li v-for="f in directory.sp_vid_doc_dz">
              <input
                v-model="reqDoc.UF_VID_DOC_DZ"
                :value="f.ID"
                type="checkbox"
              />
              <!-- это тип файла: -->
              {{ f.DESCRIPTION }}
            </li>
          </ul>
        </div>
      </td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
    </tr>
    <tr
      v-show="
        doc.IS_MULTY === 1 &&
          doc.IS_REQUEST_USER_DOC_ADD === 0 &&
          doc.IS_REQUEST_DOC === 0 &&
          doc.IS_LOAD_FILE_USER === 1 &&
          (currentUser.ACTIVE_ROLE_CODE === 'admin' ||
            currentUser.ACTIVE_ROLE_CODE ===
              'OMP_staff') /*||
            currentUser.ACTIVE_ROLE_CODE === 'lizing' ||
            currentUser.ACTIVE_ROLE_CODE === 'users'*/
      "
    >
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td style="vertical-align: top;">
        <div v-if="showAddDocForm">
          <h4 class="h4form">Введите наименование документа:</h4>
          <input
            type="text"
            class="i-main-style tab-wid-550"
            v-model="reqDoc.UF_NAME"
          />
          <br /><br />
          <button
            type="button"
            class="btn btn-info"
            style="margin-right: 20px;"
            @click="addFile(doc.TYPE_ID)"
          >
            Добавить документ
          </button>

          <button
            type="button"
            class="btn btn-close_"
            @click="showAddDocForm = false"
          >
            Отмена
          </button>
        </div>
        <b v-else>
          <a
            @click="
              showAddDocForm = true;
              directory.sp_vid_doc_dz.forEach(function(val) {
                reqDoc.UF_VID_DOC_DZ.push(val.ID);
              });
            "
            class="add-t-r"
          ></a>
          Добавить документ
        </b>
      </td>
      <td style="vertical-align: top;">
        <div v-if="showAddDocForm">
          <h4 class="h4form">Вид документа:</h4>
          <ul class="ul-list-form">
            <li v-for="f in directory.sp_vid_doc_dz">
              <input
                v-model="reqDoc.UF_VID_DOC_DZ"
                :value="f.ID"
                type="checkbox"
              />
              <!-- это тип файла: -->
              {{ f.DESCRIPTION }}
            </li>
          </ul>
        </div>
      </td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
    </tr>

    <div
      v-if="showDocHistoryDialog"
      class="modal fade in show"
      tabindex="-1"
      role="dialog"
    >
      <div class="window-doc modal-fix-h modal-stl" style="width: 1000px;">
        <h3 style="text-transform: uppercase">Загруженные документы</h3>
        <div class="wrap-win-load-history body-fix-h">
          <table style="width: 100%;">
            <tr v-for="e in docHistory">
              <td
                :style="{
                  'text-decoration': e.UF_IS_DELETE ? 'line-through' : ''
                }"
              >
                {{ e.NUMBER }}.
                <a @click="getFileDZFlow(e)">{{
                  e.UF_FILE_NAME !== "" && e.UF_FILE_NAME !== null
                    ? e.UF_FILE_NAME
                    : doc.NAME
                }}</a>
                <!--<a :href="siteUrl + e.UF_FILE" target="_blank">{{
                  doc.NAME
                }}</a>-->

                <template
                  v-if="
                    e.ID > 0 &&
                      e.UF_FILE_SIGN_AUTHOR != null &&
                      e.UF_FILE_SIGN_AUTHOR != ''
                  "
                >
                  <div class="esd-data" v-show="false">
                    <i
                      class="esd-data-link"
                      style="margin-top: 10px;"
                      @click="getECPInfoHistory(e.ID)"
                    >
                      <img src="/images/i-eds.png" />
                      {{ e.UF_FILE_SIGN_AUTHOR }}
                    </i>

                    <div
                      class="esd-data__info_history esd-data__info_history-modal"
                      v-show="resultECPFileHistory[e.ID]"
                      style="right:0;"
                    >
                      <div class="esd-close" @click="closeECPFileHistory(e.ID)">
                        <i class="esd_exit"></i>
                      </div>
                      <div v-if="resultECPFileHistory[e.ID]">
                        <p class="text-center">
                          Подлинник электронного документа, подписанного ЭЦП,
                          <br />хранится в информационной системе “Личный
                          кабинет заемщика” <br />Фонда развития промышленности
                        </p>
                        <h3 class="esd-title">Сведения о сертификате ЭП</h3>
                        <div class="container-fluid" style="padding: 0px;">
                          <div class="row" style="padding:2px 0;">
                            <div class="col-xs-4 col-md-4 stl-col-pb-8">
                              Сертификат:
                            </div>
                            <div
                              class="col-xs-8 col-md-8 stl-col-pb-8 esd_wsn esd_wsn"
                            >
                              {{ result.SERTIFICATE_NUMBER }}
                            </div>
                          </div>
                          <div class="row" style="padding:2px 0;">
                            <div class="col-xs-4 col-md-4 stl-col-pb-8">
                              Кем выдан:
                            </div>
                            <div class="col-xs-8 col-md-8 stl-col-pb-8 esd_wsn">
                              {{ result.ISSUER }}
                            </div>
                          </div>
                          <div class="row" style="padding:2px 0;">
                            <div class="col-xs-4 col-md-4 stl-col-pb-8">
                              Организация:
                            </div>
                            <div class="col-xs-8 col-md-8 stl-col-pb-8 esd_wsn">
                              {{ result.COMPANY }}
                            </div>
                          </div>
                          <div class="row" style="padding:2px 0;">
                            <div class="col-xs-4 col-md-4 stl-col-pb-8">
                              Кому выдан:
                            </div>
                            <div class="col-xs-8 col-md-8 stl-col-pb-8 esd_wsn">
                              {{ result.OWNER_FIO }}
                            </div>
                          </div>
                          <div class="row" style="padding:2px 0;" v-if="result.POSITION">
                            <div class="col-xs-4 col-md-4 stl-col-pb-8">
                              Должность:
                            </div>
                            <div class="col-xs-8 col-md-8 stl-col-pb-8 esd_wsn">
                              {{ result.POSITION }}
                            </div>
                          </div>
                          <div class="row" style="padding:2px 0;">
                            <div class="col-xs-4 col-md-4 stl-col-pb-8">
                              Действителен:
                            </div>
                            <div class="col-xs-8 col-md-8 stl-col-pb-8 esd_wsn">
                              {{ result.DATE_USE_SERTIFICATE }}
                            </div>
                          </div>
                          <div class="row" style="padding:2px 0;">
                            <div class="col-xs-4 col-md-4 stl-col-pb-8">
                              Название документа:
                            </div>
                            <div class="col-xs-8 col-md-8 stl-col-pb-8 esd_wsn">
                              {{ result.FILE_NAME }}
                            </div>
                          </div>
                          <div class="row" style="padding:2px 0;">
                            <div class="col-xs-4 col-md-4 stl-col-pb-8">
                              Дата загрузки:
                            </div>
                            <div class="col-xs-8 col-md-8 stl-col-pb-8 esd_wsn">
                              {{ result.FILE_DATE_LOAD }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </td>
              <td
                :style="{
                  'text-decoration': e.UF_IS_DELETE ? 'line-through' : ''
                }"
              >
                {{ e.USER_LOAD_NAME }}
              </td>
              <td
                :style="{
                  'text-decoration': e.UF_IS_DELETE ? 'line-through' : ''
                }"
              >
                {{ e.UF_FILE_DATE_LOAD }}
              </td>
              <td style="width: 130px;">
                <button @click="saveFile(e)" class="btn-save" type="button">
                  Скачать
                </button>
              </td>
              <td style="width: 130px;">
                <button
                  v-if="e.IS_DELETE_USER_RULES"
                  @click="deleteFile(e)"
                  class="btn-save"
                  type="button"
                >
                  Удалить
                </button>
              </td>
            </tr>
          </table>
        </div>

        <div class="text-center box-btn">
          <button
            class="btn-close"
            type="button"
            @click="showDocHistoryDialog = false"
          >
            Отмена
          </button>
        </div>
      </div>
    </div>

    <div
      v-if="showEditTable"
      class="modal fade in show"
      tabindex="-1"
      role="dialog"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              v-on:click="showEditTable = false"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">Редактирование документа</h4>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <label>Наименование документа</label>
              <input v-model="fieldName" class="form-control" />
            </div>
          </div>
          <div class="modal-footer">
            <button @click="editDocName" type="button" class="btn btn-primary">
              Изменить
            </button>
            <button
              type="button"
              class="btn btn-default"
              data-dismiss="modal"
              @click="showEditTable = false"
            >
              Отмена
            </button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>

    <div
      v-if="showCommentDialog"
      class="modal fade in show"
      tabindex="-1"
      role="dialog"
    >
      <div class="window-doc" style="width: 700px; left:30%;">
        <h3>Введите комментарий</h3>
        <div style="text-align: center; padding-bottom: 10px;">
          <textarea
            class="i-main-style t-dop-style comment-window"
            v-model="commentActual.UF_COMMENT_MANAGER"
          ></textarea>
        </div>

        <div class="text-center box-btn">
          <button
            class="btn-save btn-save-green"
            style="margin-right: 100px;"
            type="button"
            @click="
              setCommentManagerDocumentDZ(
                commentActual.ID,
                commentActual.UF_COMMENT_MANAGER,
                commentActual.isCommentRFRPMode
              )
            "
          >
            Сохранить
          </button>

          <button
            class="btn-close"
            type="button"
            @click="showCommentDialog = false"
          >
            Отмена
          </button>
        </div>
      </div>
    </div>

    <!-- Request -->
    <div
      v-if="showCreateDialog"
      class="modal fade in show"
      tabindex="-1"
      role="dialog"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              v-on:click="showCreateDialog = false"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">Создание запроса</h4>
          </div>
          <div class="modal-body boldlabel">
            <div
              class="alert alert-danger"
              v-show="addError !== ''"
              role="alert"
            >
              {{ addError }}
            </div>
            <div class="form-group">
              <label>Тип запроса <sup class="red">*</sup></label>
              <select
                class="form-control"
                v-model="newRequest.UF_TYPE_ID"
              >
                <option
                  v-for="project in directory.hl_request_type"
                  :key="project.ID"
                  :value="project.ID"
                  >{{ project.UF_NAME }}
                </option>
              </select>
            </div>
            <div class="form-group" v-if="fileCreateRequest.FILE_INFO">
              Консультация по документу
              <b>{{ fileCreateRequest.FILE_INFO.UF_NAME }}</b>
            </div>
<!--            <div class="form-group">
              <label>Тема <sup class="red">*</sup></label>
              <input
                type="text"
                class="form-control"
                v-model="newRequest.UF_THEME"
              />
            </div>-->
            <div class="form-group">
              <label>Запрос <sup class="red">*</sup></label>
              <textarea class="form-control" v-model="newRequest.UF_TEXT">
              </textarea>
            </div>
            <div class="form-group">
              <label>Исполнитель <sup class="red">*</sup></label>
              <multiselect
                label="FIO"
                style="width: 540px;height: 20px"
                class="form-control"
                :limit="1"
                :limitText="filterItemText"
                track-by="ID"
                v-model="newRequest.UF_PERFORMER_ID"
                :options="documentConf.PERFORMER_LIST_CREATE_REQUEST"
                :disabled="newRequestType().UF_DEF_PERFORMER_ID ? true : false"
                placeholder=""
              >
                <span slot="noResult">Исполнитель не найден</span>
              </multiselect>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-default"
              data-dismiss="modal"
              v-on:click="showCreateDialog = false"
            >
              Отмена
            </button>
            <button type="submit" class="btn btn-primary">
              Отправить
            </button>
          </div>
        </div>
      </div>
      <!-- /.modal-dialog -->
    </div>
    <div
      v-if="showDocumentViewer"
      class="modal fade in showDocumentViewer show"
      tabindex="-1"
      role="dialog"
    >
      <div
        class="modal-dialog"
        role="document"
        style="width: 1200px; height: 90%;"
      >
        <div class="modal-content" style="height: 100%; margin-top: 40px;">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              @click="closeViewer"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">Просмотр документа</h4>
          </div>
          <div
            class="modal-body"
            :style="{
              height: 'calc(100% - 60px)',
              overflow: isPdfFile ? 'auto' : 'hidden',
              backgroundColor: '#F5F5F5'
            }"
          >
            <!-- PDF просмотрщик -->
            <template v-if="isPdfFile">
              <div class="app-header">
                <template v-if="isLoadingViewer">Загрузка...</template>

                <template v-else>
                  <span>
                    <input
                      type="radio"
                      name="procent"
                      v-model="widthViewer"
                      :value="widthViewerStart"
                      @click="widthViewer = widthViewerStart"
                    />
                    100%

                    <input
                      type="radio"
                      name="procent"
                      v-model="widthViewer"
                      :value="(widthViewerStart * 75) / 100"
                      @click="widthViewer = (widthViewerStart * 75) / 100"
                    />
                    75%

                    <input
                      type="radio"
                      name="procent"
                      v-model="widthViewer"
                      :value="(widthViewerStart * 50) / 100"
                      @click="widthViewer = (widthViewerStart * 50) / 100"
                    />
                    50%
                  </span>

                  <span v-if="showAllPages">
                    <template v-if="pageCount > 1">
                      {{ pageCount }} страниц(ы)
                    </template>
                    <template v-else>{{ pageCount }} страница</template>
                  </span>

                  <span v-else>
                    <button :disabled="page <= 1" @click="page--">❮</button>
                    <span
                      >{{ page > 1 ? page : 1 }} /
                      {{ pageCount > 1 ? pageCount : 1 }}</span
                    >
                    <button :disabled="page >= pageCount" @click="page++">
                      ❯
                    </button>
                  </span>

                  <label>
                    <input v-model="showAllPages" type="checkbox" />
                    <span>Показать все страницы</span>
                  </label>
                </template>
              </div>
              <div class="viewer">
                <PdfEmbed
                  annotation-layer
                  text-layer
                  :page="page"
                  :source="documentUrl"
                  :width="widthViewer"
                  @loaded="handleDocumentLoad"
                  @rendered="handleDocumentRender"
                />
              </div>
            </template>

            <!-- Office просмотрщик -->
            <iframe
              v-else
              :src="documentViewerUrl"
              width="100%"
              height="100%"
              frameborder="0"
            >
            </iframe>
          </div>

          <!-- <div v-if="isPdfFile" class="pdf-controls">
            <button :disabled="currentPage <= 1" @click="currentPage--">
              Предыдущая
            </button>
            <span>{{ currentPage }} / {{ pageCount }}</span>
            <button :disabled="currentPage >= pageCount" @click="currentPage++">
              Следующая
            </button>
          </div> -->
        </div>
      </div>
    </div>
  </fragment>
</template>

<script>
import Vue from "vue";
import { ProjectsService, RequestsService } from "@/common/api.service";
import { mapGetters } from "vuex";
import { AUTH_URL } from "@/common/config";
import UploadCellAddDZ from "@/components/project/documents/UploadCellAddDZ";
import Multiselect from "vue-multiselect";
import { Dropdown as VDropdown } from "floating-vue";
const PdfEmbed = () => import("vue-pdf-embed/dist/vue2-pdf-embed");

let formatsPromise = null;
function fetchUserRequestFormats() {
  if (!formatsPromise) {
    formatsPromise = ProjectsService.getTypeFileExtensionForUserRequest()
      .then(response =>
        response.data.items
          .join(", ")
          .toUpperCase()
          .split(", ")
      )
      .catch(err => {
        formatsPromise = null;
        throw err;
      });
  }
  return formatsPromise;
}

Vue.filter("cleanFormats", function(value) {
  let formats = [];

  value.split(";").forEach(function(v) {
    if (v !== "") {
      formats.push(v);
    }
  });

  return formats.join(", ");
});

export default {
  components: {
    UploadCellAddDZ,
    Multiselect,
    VDropdown,
    PdfEmbed
  },
  props: [
    "doc",
    "docsType",
    "index",
    "documentConf",
    "docIndex",
    "documentHistory",
    "record"
  ],
  name: "TableRowAddDZ",
  data() {
    return {
      IS_ACCEPT_ELECTRONIC_FILE_MANAGER: "",
      IS_ACCEPT_PAPER_FILE_MANAGER: "",
      repeats: 1,
      result: "",
      resultECP: {},
      resultECPFile: {},
      resultECPFileHistory: {},
      showCommentDialog: false,
      commentActual: [],
      vidDoc: "",
      showManagerDialog: false,
      showDocHistoryDialog: false,
      showEditTable: false,
      docHistory: [],
      siteUrl: "",
      showAddDocForm: false,
      reqDoc: {
        UF_NAME: "",
        RECORD_MODEL_ID: this.doc.RECORD_MODEL_ID,
        UF_VID_DOC_DZ: []
      },
      fieldName: "",
      fieldId: 0,
      showCreateDialog: false,
      fileCreateRequest: [],
      newRequest: {
        UF_PROJECT_ID: "",
        UF_TYPE_ID: 6,
        UF_THEME: "",
        UF_TEXT: "",
        UF_PERFORMER_ID: "",
        UF_PERIOD_EXECUTION: "",
        UF_FILE_ID: []
      },
      addError: "",
      showDocumentViewer: false,
      documentViewerUrl: "",
      documentUrl: null,
      currentPage: 0,
      page: null,
      pageCount: null,
      isPdfFile: false,
      showAllPages: true,
      isLoadingViewer: true,
      widthViewer: 1120,
      widthViewerStart: 1120
    };
  },
  async created() {
    this.siteUrl = AUTH_URL.replace(new RegExp("[\\/]+$"), "");
  },
  watch: {
    showAllPages() {
      this.page = this.showAllPages ? null : 1;
    }
  },
  asyncComputed: {
    async formats() {
      if (
        this.doc.IS_MULTIPLY &&
        this.currentUser.TYPE_USER === "manager" &&
        this.doc.IS_FILE_MANAGER_REQUEST
      ) {
        return await fetchUserRequestFormats();
      }
      return [];
    }
  },

  computed: {
    ...mapGetters(["project", "directory", "currentUser"]),
    docs() {
      let docs = [];
      let addRow = true;
      if (!this.doc.IS_MULTIPLY) {
        if (
          this.doc.TYPE_INFO.IS_REQUEST_DOC === 0 ||
          (this.doc.TYPE_INFO.IS_REQUEST_DOC === 1 &&
            this.doc.IS_REQUEST_USER_DOC_ADD === 1)
        ) {
          if (
            this.doc.IS_MULTY === 1 &&
            this.doc.IS_REQUEST_USER_DOC_ADD === 0 &&
            this.doc.IS_REQUEST_DOC === 0
          ) {
            addRow = false;
          } else {
            addRow = true;
          }

          if (addRow) {
            docs.push(this.doc);
          }
        }
      } else {
        for (let i = 0; i < this.repeats; i++) {
          let doc = JSON.parse(JSON.stringify(this.doc));
          Vue.set(doc, "DOP", "");
          Vue.set(doc, "DOP_ID", "");
          Vue.set(doc, "DOP_COMMENT", "");
          Vue.set(doc, "A_FORMATS", []);
          if (
            this.documentConf.FILE_DOCUMENTS_PATH[doc.TYPE_ID] &&
            this.documentConf.FILE_DOCUMENTS_PATH[doc.TYPE_ID][i]
          ) {
            Vue.set(
              doc,
              "DOP",
              this.documentConf.FILE_DOCUMENTS_PATH[doc.TYPE_ID][i]
                .UF_USER_FILE_NAME
            );
            Vue.set(
              doc,
              "DOP_COMMENT",
              this.documentConf.FILE_DOCUMENTS_PATH[doc.TYPE_ID][i]
                .UF_COMMENT_MANAGER
            );
            if (
              this.documentConf.FILE_DOCUMENTS_PATH[doc.TYPE_ID][i]
                .UF_FORMAT_REQ_FILE
            ) {
              Vue.set(
                doc,
                "A_FORMATS",
                this.documentConf.FILE_DOCUMENTS_PATH[doc.TYPE_ID][
                  i
                ].UF_FORMAT_REQ_FILE.split(";")
              );
            }
            Vue.set(
              doc,
              "DOP_ID",
              this.documentConf.FILE_DOCUMENTS_PATH[doc.TYPE_ID][i].ID
            );
          }
          docs.push(doc);
        }
      }

      return docs;
    }
  },

  methods: {
    editField() {
      ProjectsService.editBlockDocumentDZ(this.project.ID, this.fieldId, {
        UF_NAME: this.fieldName
      }).then(({ data }) => {
        if (!data.error) {
          this.showEditTable = false;
          this.updateDocInfo();
        } else {
          data.errorArr.forEach(function(text) {
            this.$toasted.show(text, {
              theme: "red",
              position: "bottom-right",
              duration: 3500
            });
          }, this);
        }
      }, this);
    },
    showEditTableDialog(id, name) {
      this.showEditTable = true;
      this.fieldId = id;
      this.fieldName = name;
    },
    editDocName() {
      ProjectsService.editNameRequestDocumentDZ(this.project.ID, this.fieldId, {
        UF_NAME: this.fieldName
      }).then(({ data }) => {
        if (!data.error) {
          this.showEditTable = false;
          this.updateDocInfo();
        } else {
          data.errorArr.forEach(function(text) {
            this.$toasted.show(text.TEXT, {
              theme: "red",
              position: "bottom-right",
              duration: 3500
            });
          }, this);
        }
      }, this);
    },
    isSetAcceptManager(arr) {
      let bool = false;
      arr.forEach(el => {
        el.ACTIVE_CODE === this.currentUser.ACTIVE_ROLE_CODE
          ? (bool = true)
          : null;
      });
      return bool;
    },
    closeECP(id) {
      this.resultECP[id] = !this.resultECP[id];
    },
    setAkceptRFRPManagerDocumentDZ(idFile, id) {
      ProjectsService.setAkceptRFRPManagerDocumentDZ(this.project.ID, idFile, {
        UF_IS_AKCEPT_RFRP: id
      }).then(({ data }) => {
        if (!data.error) {
          this.updateDocInfo();
        } else {
          data.errorArr.forEach(function(text) {
            this.$toasted.show(text.TEXT, {
              theme: "red",
              position: "bottom-right",
              duration: 3500
            });
          }, this);
        }
      });
    },
    setElectornViewManagerDocumentDZ(idFile, id) {
      ProjectsService.setElectornViewManagerDocumentDZ(
        this.project.ID,
        idFile,
        {
          UF_ELECTRON_VIEW_ID: id
        }
      ).then(({ data }) => {
        if (!data.error) {
          this.updateDocInfo();
        } else {
          data.errorArr.forEach(function(text) {
            this.$toasted.show(text.TEXT, {
              theme: "red",
              position: "bottom-right",
              duration: 3500
            });
          }, this);
        }
      });
    },
    setPaperViewManagerDocumentDZ(idFile, id) {
      ProjectsService.setPaperViewManagerDocumentDZ(this.project.ID, idFile, {
        UF_PAPER_VIEW_ID: id
      }).then(({ data }) => {
        if (!data.error) {
          this.updateDocInfo();
        } else {
          data.errorArr.forEach(function(text) {
            this.$toasted.show(text.TEXT, {
              theme: "red",
              position: "bottom-right",
              duration: 3500
            });
          }, this);
        }
      });
    },
    setCommentManagerDocumentDZ(idFile, comment, isRFRPMode) {
      ProjectsService.setCommentManagerDocumentDZ(this.project.ID, idFile, {
        UF_COMMENT_MANAGER: comment,
        isCommentRFRPMode: isRFRPMode
      }).then(({ data }) => {
        if (!data.error) {
          this.showCommentDialog = false;
          if (isRFRPMode) {
            this.commentActual.FILE.UF_COMMENT_MANAGER_RFRP = comment;
          } else {
            this.commentActual.FILE.UF_COMMENT_MANAGER = comment;
          }
        } else {
          data.errorArr.forEach(function(text) {
            this.$toasted.show(text.TEXT, {
              theme: "red",
              position: "bottom-right",
              duration: 3500
            });
          }, this);
        }
      });
    },
    getECPUserInfo(idUser) {
      Vue.set(this.resultECP, [idUser], true);
      ProjectsService.getECPUserInfo(idUser).then(({ data }) => {
        this.result = data;
        this.resultECP[idUser] = true;
      });
    },
    listConfig(doc) {
      const q = {
        isArchive: doc.IS_ACTUAL_VERSION ? 0 : 1
      };

      return q;
    },

    saveFile(file) {
      if (!file || !file.ID) {
        console.error("Invalid file data");
        return;
      }

      ProjectsService.getLinkByFileFLowDZ(
        file.UF_PROJECT_ID,
        file.ID,
        this.listConfig(file)
      )
        .then(({ data }) => {
          try {
            if (data.error) {
              throw new Error(data.error);
            }

            const fileUrl =
              AUTH_URL.replace(new RegExp("[\\/]+$"), "") + data.link;

            const link = document.createElement("a");
            link.href = fileUrl;

            const fileName = file.UF_FILE_NAME || file.NAME || "download";
            link.download = fileName;

            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          } catch (error) {
            console.error("Error:", error);
            this.$toasted.show("Ошибка при скачивании файла", {
              theme: "red",
              position: "bottom-right",
              duration: 3500
            });
          }
        })
        .catch(error => {
          console.error("Error fetching file link:", error);
          this.$toasted.show("Ошибка при получении ссылки на файл", {
            theme: "red",
            position: "bottom-right",
            duration: 3500
          });
        });
    },

    getFileDZFlow(file) {
      if (!file || !file.ID) {
        console.error("Invalid file data");
        return;
      }

      const fileName = file.UF_FILE_NAME || "";
      const extension = fileName
        .split(".")
        [fileName.split(".").length - 1].toLowerCase();

      const supportedExtensions = [
        "doc",
        "docx",
        "ppt",
        "pptx",
        "pdf",
        "xls",
        "xlsx"
      ];

      if (!supportedExtensions.includes(extension)) {
        window.location.href = file.FILE;
        return;
      }

      if (extension === "pdf") {
        ProjectsService.getLinkByFileFLowDZ(
          file.UF_PROJECT_ID,
          file.ID,
          this.listConfig(file)
        )
          .then(({ data }) => {
            try {
              if (data.error) {
                throw new Error(data.error);
              }
              const fileUrl =
                AUTH_URL.replace(new RegExp("[\\/]+$"), "") + data.link;
              this.isPdfFile = true;
              this.showDocumentViewer = true;
              this.documentUrl = fileUrl;
            } catch (error) {
              console.error("Error:", error);
              this.$toasted.show("Ошибка при получении PDF файла", {
                theme: "red",
                position: "bottom-right",
                duration: 3500
              });
            }
          })
          .catch(error => {
            console.error("Error fetching PDF link:", error);
            this.$toasted.show("Ошибка при загрузке ссылки на PDF", {
              theme: "red",
              position: "bottom-right",
              duration: 3500
            });
          });
      } else {
        this.isPdfFile = false;
        const encodedUrl = encodeURIComponent(file.FILE);
        this.documentViewerUrl = `https://view.officeapps.live.com/op/embed.aspx?src=${encodedUrl}`;
        this.showDocumentViewer = true;
      }
    },

    closeViewer() {
      this.showDocumentViewer = false;
      if (this.documentUrl) {
        URL.revokeObjectURL(this.documentUrl);
      }
      this.documentUrl = null;
      this.documentViewerUrl = "";
      this.isPdfFile = false;
      this.currentPage = 1;
      this.pageCount = null;
      this.page = null;
      //this.widthViewer = widthViewerStart;
    },

    addFile(typeId) {
      ProjectsService.addRequestDocumentDZ(
        this.project.ID,
        typeId,
        this.reqDoc
      ).then(response => {
        if (!response.data.error) {
          this.showAddDocForm = false;
          this.updateDocInfo();
        } else {
          response.data.errorArr.forEach(function(text) {
            this.$toasted.show(text.TEXT, {
              theme: "red",
              position: "bottom-right",
              duration: 3500
            });
          }, this);
        }
      }, this);
    },
    isInRequestManagerList(doc) {
      if (!doc.GROUP_REQUEST_MANAGER_LIST) {
        return false;
      }
      return doc.GROUP_REQUEST_MANAGER_LIST.some(
        role => role.ACTIVE_CODE === this.currentUser.ACTIVE_ROLE_CODE
      );
    },
    isManagerRequest(doc) {
      if (this.currentUser.TYPE_USER !== "manager") {
        return false;
      }
      if (!doc.IS_FILE_MANAGER_REQUEST) {
        return false;
      }
      let r = false;
      doc.GROUP_REQUEST_MANAGER_LIST.forEach(function(role) {
        if (role.ACTIVE_CODE === this.currentUser.ACTIVE_ROLE_CODE) {
          r = true;
        }
      }, this);
      return r;
    },
    showDocHistory(id) {
      this.docHistory = [];
      ProjectsService.getDocumenetHistoryDZ(this.project.ID, id).then(
        ({ data }) => {
          this.showDocHistoryDialog = true;
          this.docHistory = data.FILE_LIST;
        },
        this
      );
    },
    updateDocInfo() {
      ProjectsService.getDocumentDZProjects(this.$route.params.id).then(
        ({ data }) => {
          this.documentConf.FILE_LOAD_INFO = data.FILE_LOAD_INFO;
          this.documentConf.FILE_ACCEPT_INFO_RFRP = data.FILE_ACCEPT_INFO_RFRP;
          this.documentConf.FILE_ACCEPT_INFO_ELECTRONIC_VIEW =
            data.FILE_ACCEPT_INFO_ELECTRONIC_VIEW;
          this.documentConf.FILE_ACCEPT_INFO_PAPER_VIEW =
            data.FILE_ACCEPT_INFO_PAPER_VIEW;
          this.documentConf.LIST_TYPE = data.LIST_TYPE;
          this.documentConf.SHOW_SAVE_SESSION = data.SHOW_SAVE_SESSION;
          this.documentConf.IS_BLOCK_BUTTON_SET_VERSION =
            data.IS_BLOCK_BUTTON_SET_VERSION;
        },
        this
      );
    },
    acceptAvailable() {
      let m = false;
      this.doc.ACCEPT_MANAGER_LIST.forEach(function(r) {
        if (r.ACTIVE_CODE === this.currentUser.ACTIVE_ROLE_CODE) {
          m = true;
        }
      }, this);
      return m;
    },
    deleteDocument(id) {
      if (confirm("Вы действительно хотите удалить документ?")) {
        ProjectsService.deleteDocumentDZ(this.project.ID, id).then(
          ({ data }) => {
            if (data.error === false) {
              this.updateDocInfo();
              this.$toasted.show("Документ успешно удален", {
                theme: "green",
                position: "bottom-right",
                duration: 3500
              });
            } else {
              data.errorArr.forEach(function(text) {
                this.$toasted.show(text.TEXT, {
                  theme: "red",
                  position: "bottom-right",
                  duration: 3500
                });
              }, this);
            }
          },
          this
        );
      }
    },
    deleteFile(file) {
      ProjectsService.deleteFileDZ(this.project.ID, file.ID, {
        IS_ACTUAL_VERSION: file.IS_ACTUAL_VERSION
      }).then(({ data }) => {
        if (data.error === false) {
          this.updateDocInfo();
          this.showDocHistory(this.doc.FILE_INFO.ID);
        } else {
          data.errorArr.forEach(function(text) {
            this.$toasted.show(text.TEXT, {
              theme: "red",
              position: "bottom-right",
              duration: 3500
            });
          }, this);
        }
      }, this);
    },
    showComment(file, isRFRP) {
      this.commentActual = [];
      this.commentActual.ID = file.ID;
      this.commentActual.UF_COMMENT_MANAGER = isRFRP
        ? file.UF_COMMENT_MANAGER_RFRP
        : file.UF_COMMENT_MANAGER;
      this.commentActual.FILE = file;
      this.commentActual.isCommentRFRPMode = isRFRP;
      this.showCommentDialog = true;
    },
    showWindowCreateRequest(file) {
      this.newRequest.UF_PERFORMER_ID = this.documentConf.PERFORMER_CREATE_REQUEST_DEF
      this.showCreateDialog = true;
      this.fileCreateRequest = file;
    },
    createRequest() {
      let formData = new FormData();
      formData.append("UF_PROJECT_ID", this.project.ID);
      formData.append("UF_TYPE_ID", this.newRequest.UF_TYPE_ID);
      formData.append("UF_THEME", this.newRequest.UF_THEME);
      formData.append("UF_TEXT", this.newRequest.UF_TEXT);
      formData.append("UF_DOC_DZ_ID", this.fileCreateRequest.FILE_INFO.ID);
      formData.append(
        "UF_PERFORMER_ID",
        this.newRequest.UF_PERFORMER_ID[0]
          ? this.newRequest.UF_PERFORMER_ID[0].ID
          : this.newRequest.UF_PERFORMER_ID.ID
      );
      RequestsService.createRequest(formData).then(({ data }) => {
        if (data.error) {
          this.$toasted.show(data.errorArr[0].TEXT, {
            theme: "red",
            position: "bottom-right",
            duration: 3500
          });
        } else {
          //this.updateDocInfo();
          this.showCreateDialog = false;

          this.$toasted.show("Запрос успешно создан", {
            theme: "green",
            position: "bottom-right",
            duration: 3000
          });
        }
      });
    },
    filterItemText(count) {
      return `и еще ${count}`;
    },
    newRequestType() {
      let t = this.directory.hl_request_type.filter(
        c => c.ID === this.newRequest.UF_TYPE_ID.ID
      );
      if (t && t.length > 0) {
        return t[0];
      }
      return {};
    },
    getECPInfo(idFile) {
      ProjectsService.getECPInfoFileDZ(this.project.ID, idFile).then(
        ({ data }) => {
          this.result = data.result;
          Vue.set(this.resultECPFile, [idFile], true);
          this.resultECPFile[idFile] = true;
        }
      );
    },
    getECPInfoHistory(idFile) {
      ProjectsService.getECPInfoHistoryFileDZ(this.project.ID, idFile).then(
        ({ data }) => {
          this.result = data.result;
          Vue.set(this.resultECPFileHistory, [idFile], true);
          this.resultECPFileHistory[idFile] = true;
        }
      );
    },
    closeECPFile(id) {
      this.resultECPFile[id] = !this.resultECPFile[id];
    },
    closeECPFileHistory(id) {
      this.resultECPFileHistory[id] = !this.resultECPFileHistory[id];
    },
    handleDocumentLoad({ numPages }) {
      this.pageCount = numPages;
    },
    handleDocumentRender() {
      this.isLoadingViewer = false;
    }
  }
};
</script>

<style scoped>
.modal.show {
  display: block;
  background: rgba(0, 0, 0, 0.5);
}

.window-doc {
  position: fixed;
  top: 5%;
  left: 5%;
  z-index: 1050;
  background: white;
  border-radius: 4px;
}

.modal-header {
  padding: 15px;
  border-bottom: 1px solid #e5e5e5;
}

.modal-body {
  padding: 15px;
}

.pdf-controls {
  position: fixed;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  background: white;
  padding: 10px;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  display: flex;
  gap: 10px;
  align-items: center;
}

.pdf-controls button {
  padding: 5px 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  background: white;
  cursor: pointer;
}

.pdf-controls button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
</style>
